import type { AttributeReviewSessionsUnderReviewQuery } from "@/graphql/generated";

type SessionList = AttributeReviewSessionsUnderReviewQuery | undefined;

export function withoutSession(
  current: SessionList,
  sessionId: string,
): SessionList {
  if (!current?.attributeReviewSessionsUnderReview) return current;
  return {
    ...current,
    attributeReviewSessionsUnderReview:
      current.attributeReviewSessionsUnderReview.filter(
        (session) => session.mappingSessionId !== sessionId,
      ),
  };
}
